module.exports = __webpack_public_path__ + "static/media/image-card-6.ad7c2640.png";